import React, { useEffect, type PropsWithChildren } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import { v4 as uuidv4 } from 'uuid';
import { verifyUser } from 'store/authSlice';
import type { RootState, AppDispatch } from 'store/store';

type CookieKeys = 'CookieId';

const LoginVerification: React.FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [cookies, setCookie, removeCookie] = useCookies<CookieKeys>([
    'CookieId',
  ]);
  const token = useSelector((state: RootState) => state.auth.token);

  useEffect(() => {
    // Kick off a silent verification on mount
    dispatch(verifyUser());
  }, [dispatch]);

  useEffect(() => {
    if (token) {
      deleteCookie();
    } else {
      cookieManagement();
    }
    // Including stable setters from react-cookie is fine; they are memoized
  }, [token, cookies.CookieId, removeCookie, setCookie]);

  const deleteCookie = (): void => {
    removeCookie('CookieId', { path: '/' });
  };

  const cookieManagement = (): void => {
    if (!cookies.CookieId) {
      const expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 30);
      const uuid = uuidv4();
      setCookie('CookieId', uuid, { path: '/', expires: expireDate });
    }
  };

  return <>{children}</>;
};

export default LoginVerification;
